import { combineReducers } from 'redux'
import activeStudentCalendars from './activeStudentCalendars'
import cohorts from './cohorts'
import courses from './courses'
import course from './course'
import enrolmentWorkflows from './enrolmentWorkflows'
import isSearchActive from './isSearchActive'
import page from './page'
import sliders from './sliders'
import teachingCalendars from './teachingCalendars'
import units from './units'
import personalDetails from './personalDetails'
import tiles from './tiles'
import currentUser from './currentUser'
import enrolledTeachingPeriods from './enrolledTeachingPeriods'
import maintenancePeriods from './maintenancePeriods'
import enrolmentContainer from './enrolmentContainer'

export default combineReducers({
  activeStudentCalendars,
  cohorts,
  courses,
  course,
  enrolmentWorkflows,
  isSearchActive,
  page,
  sliders,
  teachingCalendars,
  tiles,
  units,
  currentUser,
  enrolledTeachingPeriods,
  personalDetails,
  maintenancePeriods,
  enrolmentContainer
})
